import styled from 'styled-components';

const Box = styled.div`
    box-sizing: border-box;
    margin: 0;
    min-width: 0;
`;

export default Box;